import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of, Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ActionsService {
  constructor() {}
  private action = new Subject<string>()

  getActions(): Subject<string> {
    return this.action
  }

  setAction(action: string) {
    this.action.next(action)
  }
}
